module.exports = __webpack_public_path__ + "img/YAKINIKU SMILE.b24d6d96.svg";